<template>
    <div class="table-action">
        <div class="table-action__toggle"
             aria-haspopup="true"
             :aria-expanded="isOpen"
             @click.prevent="isOpen = !isOpen"
        >
            <div v-show="isOpen">
                <button
                class="table-action-button"
                v-pre
                >
                    <img
                        src="/images/actions/close.svg"/>
                </button>
            </div>


            <div class="h:padding-right-2" v-show="!isOpen">
                <button
                class="table-action-button"
                v-pre
                >
                    <img
                        src="/images/actions/trigger.svg"/>
                </button>
            </div>
        </div>

        <transition name="table-action-menu-transition"
        >
            <div v-show="isOpen"
                class="table-action__menu table-action-menu"
                :class="[position,width]"
            >
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    import { onKeyPress } from '../../util/onKeyPress';
    import { onClickOutside } from '../../util/onClickOutside';


    export default {
        props: {
            position: { default: 'table-action-menu--default'},
            width: { default: 'table-action-menu--default-width'}
        },

        data() {
            return {
                isOpen: false
            }
        },

        mounted() {
            onKeyPress('esc', this.closeActionMenu);

            onClickOutside(this.$el, this.closeActionMenu);
        },

        methods: {
            closeActionMenu() {
                this.isOpen = false;
            }
        }
    }
</script>

